const DRAFT_KEY = "modulo_quotation_draft_v1";

// One-time cleanup: earlier builds kept the draft (customer PII) in
// localStorage. Drafts now live in sessionStorage only (per-tab, cleared
// when the browser closes).
try {
  localStorage.removeItem(DRAFT_KEY);
} catch {
  /* storage unavailable */
}

export const loadDraft = () => {
  try {
    const raw = sessionStorage.getItem(DRAFT_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    // Validate shape on retrieval — reject anything that isn't a plausible
    // quotation draft (defense against tampered/corrupted storage).
    if (
      !parsed ||
      typeof parsed !== "object" ||
      Array.isArray(parsed) ||
      (parsed.customer && typeof parsed.customer !== "object") ||
      (parsed.rooms && !Array.isArray(parsed.rooms)) ||
      (parsed.accessories && !Array.isArray(parsed.accessories))
    ) {
      sessionStorage.removeItem(DRAFT_KEY);
      return null;
    }
    return parsed;
  } catch (e) {
    console.warn("Failed to read quotation draft:", e);
    return null;
  }
};

export const saveDraft = (data) => {
  try {
    sessionStorage.setItem(DRAFT_KEY, JSON.stringify(data));
  } catch (e) {
    console.warn("Failed to persist quotation draft:", e);
  }
};

export const clearDraft = () => {
  try {
    sessionStorage.removeItem(DRAFT_KEY);
  } catch (e) {
    console.warn("Failed to clear quotation draft:", e);
  }
};
